import { render, staticRenderFns } from "./device-info.vue?vue&type=template&id=ef55501a&scoped=true&"
import script from "./device-info.vue?vue&type=script&lang=js&"
export * from "./device-info.vue?vue&type=script&lang=js&"
import style0 from "./device-info.vue?vue&type=style&index=0&id=ef55501a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef55501a",
  null
  
)

export default component.exports